import BSN from "bootstrap.native"
import Tabulator from "tabulator-tables";
import AutoNumeric from 'autonumeric';
import { ApplicationController } from "../application_controller";

export default class extends ApplicationController {
  static targets = ["table", "form", "mapping_dropdown", "mapping_checkbox",
    "transaction_currency_radio_template", "modal_currencies_radio",
    "modal_currency_text",
    "to_main_rate_field", "from_main_rate_field",
    "to_additional_rate_field", "from_additional_rate_field",
    "filter_period", "filter_transaction_type", "filter_purpose",
    "filter_account", "filter_pay_type", "filter_associated", 
    "filter_search", "current_balance_info", "current_balance_display", "validation_message"]


  connect() {
    this.currentCurrency = null;
    
    // Main table
    if (this.hasTableTarget) {
      const content_url = this.data.get("table-load-url");
      this.createTable(content_url);
    }

    // Load current balance for expense forms
    if (this.hasCurrent_balance_displayTarget) {
      this.loadCurrentBalance();
    }

    if (this.hasFormTarget) {
      const form_id = this.formTarget.getAttribute("id");
      // Load dynamic exchange rates for expense forms on initial load
      if (this.isExpenseForm() && form_id === "cashbox_transactions_form") {
        const selectedCurrency = this.getSelectedCurrency();
        if (selectedCurrency) {
          this.currentCurrency = selectedCurrency;
          this.loadDynamicExchangeRates(selectedCurrency);
        }
      }
    }
  }

  onPostPutSuccess(event) {
    const [data, status, xhr] = event.detail;
    if (data) {
      // show notify
      window.vNotify.success({ text: data.notification_message, title: data.notification_title });

      const rowId = data.id;
      const rowAction = data.row_action;
      const rowData = data.data;

      // update table data
      this.updateTable(rowId, rowAction, rowData);

      const table = document.getElementById("cashbox_transactions_totals_table")
      table.querySelector(".totals_incomes").innerHTML  = data.total_incomes;
      table.querySelector(".totals_expenses").innerHTML = data.total_expenses;
      table.querySelector(".totals_conversions").innerHTML = data.total_conversions;

      // update balance table if present
      if (data.balance_table_content) {
        const balanceContainer = document.getElementById("balance_table_container");
        if (balanceContainer) {
          balanceContainer.innerHTML = data.balance_table_content;
        }
      }

      // hide form modal
      if (data.save_and_new === true || data.save_and_new === "true") {
        // modal set content
        window.layout_modal_md.setContent(data.form_content)
      } else {
        window.layout_modal_md.hide();
      }
    }
  }

  onPostPutError(event) {
    const [data, status, xhr] = event.detail;
    
    if (data.form_content) {
      window.layout_modal_md.setContent(data.form_content);
    }
  }

  openModal(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");

    let filters = []
    if (this.hasFilter_periodTarget && this.filter_periodTarget.value != '') {
      filters.push("start_at_end_at_period=" + this.filter_periodTarget.value);
    }
    if (this.hasFilter_transaction_typeTarget && this.filter_transaction_typeTarget.choices.getValue(true) != '') {
      filters.push("transaction_type_ids=" + this.filter_transaction_typeTarget.choices.getValue(true));
    }
    if (this.hasFilter_purposeTarget && this.filter_purposeTarget.choices.getValue(true) != '') {
      filters.push("purpose_ids=" + this.filter_purposeTarget.choices.getValue(true));
    }
    if (this.hasFilter_accountTarget && this.filter_accountTarget.choices.getValue(true) != '') {
      filters.push("account_ids=" + this.filter_accountTarget.choices.getValue(true));
    }
    if (this.hasFilter_pay_typeTarget && this.filter_pay_typeTarget.choices.getValue(true) != '') {
      filters.push("pay_type_ids=" + this.filter_pay_typeTarget.choices.getValue(true));
    }
    if (this.hasFilter_associatedTarget && this.filter_associatedTarget.choices.getValue(true) != '') {
      filters.push("associated_ids=" + this.filter_associatedTarget.choices.getValue(true));
    }
    filters = filters.join("&")
    if (filters.length) {
      url += (url.search(/\?/) > 0 ? "&" : "?") + filters
    }

    this.openLayoutModalMD(url);
  }

  mappingOpen(event) {
    if (this.hasMapping_dropdownTarget) {
      const mapping_dropdown = this.mapping_dropdownTarget;
      new BSN.Dropdown(mapping_dropdown).toggle();
    }
  }

  mappingNotCloseClick(event) {
    event.stopPropagation();
  }

  updateTransactionInputCurrencies(element) {
    let currency = element.getAttribute("value");
    let info_data = element.getAttribute("data-currency-info");
    let from_main_field = this.from_main_rate_fieldTarget;
    let to_additional_field = this.to_additional_rate_fieldTarget;

    this.modal_currency_textTarget.innerHTML = currency;

    if (info_data){
      info_data = JSON.parse(info_data);

      const from_main_input = document.querySelector('input[name="cashbox_transaction[from_main_rate]"]');
      const to_additional_input = document.querySelector('input[name="cashbox_transaction[to_additional_rate]"]');
      
      // For expense forms, skip updating input values here since dynamic rates will be loaded
      if (!this.isExpenseForm()) {
        if (from_main_input) {
          from_main_input.value = info_data["from_main_rate"] || 1.0;
        }
        if (to_additional_input) {
          to_additional_input.value = info_data["to_additional_rate"] || 1.0;
        }
      }

      // For expense forms, skip all display updates to avoid blinking
      if (!this.isExpenseForm()) {
        if (info_data["is_main"] == true){
          from_main_field.classList.add("hidden");
        } else {
          from_main_field.classList.remove("hidden");
          if (info_data["from_main_display"]) {
            from_main_field.querySelector(".exchange-rate-display span").innerHTML = info_data["from_main_display"];
          }
        }

        if (info_data["is_additional"] == true){
          to_additional_field.classList.add("hidden");
        } else {
          to_additional_field.classList.remove("hidden");
          if (info_data["to_additional_display"]) {
            to_additional_field.querySelector(".exchange-rate-display span").innerHTML = info_data["to_additional_display"];
          }
        }
      }
    }
  }

  filterTable() {
    this.setFilterToTable();
  }

  // Main table filters
  setFilterToTable() {
    let table = this.tableTarget.tabulator;
    let filters = this.getPageFilters();

    if (filters.length) {
      table.setFilter(filters);
    }
  }


  getPageFilters() {
    let filters = []

    if (this.hasFilter_searchTarget) {
      filters.push({
        field: "q",
        type: "=",
        value: this.filter_searchTarget.value
      })
    }

    if (this.hasFilter_periodTarget) {
      filters.push({
        field: "start_at_end_at_period",
        type: "=",
        value: this.filter_periodTarget.value || this.filter_periodTarget.getAttribute("data-period")
      })
    }

    if (this.hasFilter_transaction_typeTarget) {
      filters.push({
        field: "transaction_type_ids",
        type: "=",
        value: this.getSelectCollectionValues(this.filter_transaction_typeTarget)
      })
    }

    if (this.hasFilter_purposeTarget) {
      filters.push({
        field: "purpose_ids",
        type: "=",
        value: this.getSelectCollectionValues(this.filter_purposeTarget)
      })
    }

    if (this.hasFilter_accountTarget) {
      filters.push({
        field: "account_ids",
        type: "=",
        value: this.getSelectCollectionValues(this.filter_accountTarget)
      })
    }

    if (this.hasFilter_pay_typeTarget) {
      filters.push({
        field: "pay_type_ids",
        type: "=",
        value: this.getSelectCollectionValues(this.filter_pay_typeTarget)
      })
    }

    if (this.hasFilter_associatedTarget) {
      filters.push({
        field: "associated_ids",
        type: "=",
        value: this.getSelectCollectionValues(this.filter_associatedTarget)
      })
    }

    return filters;
  }

  // Create main table
  async createTable(url) {
    const columns = this.data.get("table-columns");
    const table_target = this.tableTarget;

    const default_props = super.tabulatorDefaultProps
    const height = document.getElementById('content').clientHeight;
    const sort_column = this.data.get("sort-column");
    const sort_dir = this.data.get("sort-dir");

    const footer_labels = JSON.parse(this.data.get("footer-labels"));

    let table_props = {
      layout: "fitDataTable",
      virtualDomBuffer: 4000,
      index: "id",
      height: (height - 180) + "px",
      persistenceID: "cashbox_transactions_table",
      movableColumns: true,
      // columns
      columns: JSON.parse(columns),
      // headerSort: false,
      // sort
      initialSort: [
        { column: sort_column, dir: sort_dir }
      ],
      initialFilter: this.getPageFilters(),
      pagination: "remote",
      paginationDataSent: {
        "size": "per_page"
      },
      paginationSize: 25,
      paginationSizeSelector: [10, 25, 50],
      // Ajax
      ajaxURL: url,
      ajaxSorting: true,
      ajaxFiltering: true,
      ajaxLoader: true,
      ajaxLoaderLoading: "<div class='loader' > Loading...</div> ",
      footerElement: "<table class='table table-striped table-heading-fixed' id='cashbox_transactions_totals_table'> \
          <tfoot> \
            <tr>  \
              <td class='text-right' style='width: 30%'> \
                <strong class='font-size-16'>" + footer_labels['total_label'] + "</strong> \
              </td> \
              <td class='text-right td-w-100'/> \
              <td class='text-right td-w-60'> \
                <strong class='font-size-16'>" + footer_labels['incomes_label'] + "</strong> \
              </td> \
              <td class='text-right td-w-100 totals_incomes'/> \
              <td class='text-right td-w-60'> \
                <strong class='font-size-16'>" + footer_labels['expenses_label'] + "</strong> \
              </td> \
              <td class='text-right td-w-100 totals_expenses'/> \
              <td class='text-right td-w-60'> \
                <strong class='font-size-16'>" + footer_labels['conversions_label'] + "</strong> \
              </td> \
              <td class='text-right td-w-100 totals_conversions'/> \
              <td class='text-right' style='width: 20%'/>  \
            </tr>  \
          </tfoot> \
        </table>",
      rowFormatter: function (row) {
        const data = row.getData();
        if (data.cashbox_transaction__status) {
          row.getElement().classList.add("row-" + data.cashbox_transaction__status)
        }
      },
      ajaxResponse:function(url, params, response){
        const table = document.getElementById("cashbox_transactions_totals_table")
        table.querySelector(".totals_incomes").innerHTML = response.total_incomes;
        table.querySelector(".totals_expenses").innerHTML = response.total_expenses;
        table.querySelector(".totals_conversions").innerHTML = response.total_conversions;

        return response;
      }
    }

    table_props = Object.assign(default_props, table_props);
    // create table
    table_target.tabulator = new Tabulator(table_target, table_props);
    table_target.tabulator.setLocale(super.appLocale);
  }

  async updateTable(rowId, rowAction, rowData, total) {
    const mainTable = document.getElementById("cashbox_transactions_table");
    const mainTabulator = mainTable.tabulator;

    switch (rowAction) {
      case "add":
        mainTabulator.addRow(rowData, true);
        mainTabulator.scrollToRow(rowId, "top", false);
        break;
      case "update":
        mainTabulator.updateRow(rowId, rowData);
        break;
      case "delete":
        mainTabulator.deleteRow(rowId);
        break;
    }

  }


  getSelectCollectionValues(target) {
    if (target.choices) {
      return target.choices.getValue(true)
    } else if (target.getAttribute("data-selected")) {
      return JSON.parse(target.getAttribute("data-selected"));
    } else {
      return Array.apply(null, target.selectedOptions).map(function (el) { return el.value; });
    }
  }

  setFormat(value) {
    if (!value)
      return 0;
    return AutoNumeric.format(value, {
      allowDecimalPadding: "floats",
      decimalPlaces: 2,
      digitGroupSeparator: " ",
      decimalCharacter: ".",
      decimalCharacterAlternative: ",",
      styleRules: {
        positive: "autoNumeric-positive"
      },
      minimumValue: 0
    });
  }

  // Load current balance for selected currency
  async loadCurrentBalance() {
    const selectedCurrency = this.getSelectedCurrency();
    if (!selectedCurrency) return;
    
    try {
      const response = await fetch('/cashbox/transactions/available_balances', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (response.ok) {
        const balances = await response.json();
        this.availableBalances = balances;
        this.displayCurrentBalance(selectedCurrency);
      } else {
        console.error('Error loading balance:')
      }
    } catch (error) {
      console.error('Error loading balance:', error);
    }
  }

  // Display current balance for selected currency
  displayCurrentBalance(currency) {
    if (!this.hasCurrent_balance_displayTarget) return;
    
    const currencyBalance = this.availableBalances.find(b => b.currency === currency);
    if (currencyBalance) {
      const balanceClass = currencyBalance.balance_cents > 0 ? 'text-success' : 'text-danger';
      const balanceHTML = `
        <span class="${balanceClass}">${currencyBalance.balance_formatted}</span>
      `;
      this.current_balance_displayTarget.innerHTML = balanceHTML;
    } else {
      this.current_balance_displayTarget.innerHTML = `<span class="text-muted">${currency}: 0</span>`;
    }
  }
  // Get currently selected currency
  getSelectedCurrency() {
    const checkedRadio = document.querySelector('input[name="cashbox_transaction[amount_currency]"]:checked');
    return checkedRadio ? checkedRadio.value : null;
  }

  // Get numeric value from amount field, handling IMask formatting
  getAmountValue() {
    const amountField = document.querySelector('input[name="cashbox_transaction[amount]"]');
    if (!amountField) return 0;

    let value = amountField.value;
    
    // If IMask is applied, try to get the unmasked value
    if (amountField.inputmask && amountField.inputmask.unmaskedvalue) {
      value = amountField.inputmask.unmaskedvalue();
    }
    
    // Clean up: remove spaces and convert comma to dot
    value = value.toString().replace(/\s/g, '').replace(',', '.');
    
    return parseFloat(value) || 0;
  }

  // Show validation message
  showValidationMessage(message, type) {
    if (this.hasValidation_messageTarget) {
      this.validation_messageTarget.innerHTML = `
        <div class="alert alert-${type} mb-0 py-2">
          <small>${message}</small>
        </div>
      `;
      this.validation_messageTarget.style.display = 'block';
    }
  }

  // Hide validation message
  hideValidationMessage() {
    if (this.hasValidation_messageTarget) {
      this.validation_messageTarget.style.display = 'none';
    }
  }

  // Update currency fields and refresh balance info
  updateCurrencyFields(event) {
    const currency = event.currentTarget;
    const selectedCurrency = currency.getAttribute("value");
    
    if (this.currentCurrency === selectedCurrency) {
      return; // No change, skip API calls
    }
    
    this.currentCurrency = selectedCurrency;
    
    this.updateTransactionInputCurrencies(currency);
    
    // Update current balance for the new currency
    if (this.hasCurrent_balance_displayTarget) {
      if (this.availableBalances) {
        this.displayCurrentBalance(selectedCurrency);
      } else {
        this.loadCurrentBalance();
      }
    }
    
    // Load dynamic exchange rates for expense transactions
    if (this.isExpenseForm()) {
      this.loadDynamicExchangeRates(selectedCurrency);
    }
    
    // Re-validate amount if there's a value - use setTimeout to ensure currency change is processed
    const amountField = document.querySelector('input[name="cashbox_transaction[amount]"]');
    if (amountField && this.getAmountValue() > 0) {
      this.validateExpenseAmount({ target: amountField });
    }
  }

  // Check if this is an expense form
  isExpenseForm() {
    const transactionTypeField = document.querySelector('input[name="cashbox_transaction[transaction_type]"]');
    return transactionTypeField && transactionTypeField.value === 'expense';
  }

  // Load dynamic exchange rates from API
  async loadDynamicExchangeRates(currency, amount = null) {
    if (!currency) return;
    
    try {
      const currentAmount = amount || this.getAmountValue();
      const params = new URLSearchParams({
        currency: currency,
        amount: currentAmount
      });
      
      const response = await fetch(`/cashbox/transactions/expense_exchange_rates?${params}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (response.ok) {
        const rates = await response.json();
        this.updateExchangeRateFields(rates);
      } else {
        console.error('Failed to load dynamic exchange rates:', response.statusText);
      }
    } catch (error) {
      console.error('Error loading dynamic exchange rates:', error);
    }
  }

  // Update exchange rate input fields and displays
  updateExchangeRateFields(rates) {
    // Update hidden rate fields
    const fromMainInput = document.querySelector('input[name="cashbox_transaction[from_main_rate]"]');
    const toAdditionalInput = document.querySelector('input[name="cashbox_transaction[to_additional_rate]"]');
    
    if (fromMainInput) {
      fromMainInput.value = rates.from_main_rate || 1.0;
    }
    if (toAdditionalInput) {
      toAdditionalInput.value = rates.to_additional_rate || 1.0;
    }

    // Update display fields
    if (this.hasFrom_main_rate_fieldTarget && rates.from_main_display) {
      const displaySpan = this.from_main_rate_fieldTarget.querySelector('.exchange-rate-display span');
      if (displaySpan) {
        displaySpan.innerHTML = rates.from_main_display;
      }
    }

    if (this.hasTo_additional_rate_fieldTarget && rates.to_additional_display) {
      const displaySpan = this.to_additional_rate_fieldTarget.querySelector('.exchange-rate-display span');
      if (displaySpan) {
        displaySpan.innerHTML = rates.to_additional_display;
      }
    }

    // Show/hide rate fields based on currency
    if (this.hasFrom_main_rate_fieldTarget) {
      if (rates.is_main) {
        this.from_main_rate_fieldTarget.classList.add('hidden');
      } else {
        this.from_main_rate_fieldTarget.classList.remove('hidden');
      }
    }

    if (this.hasTo_additional_rate_fieldTarget) {
      if (rates.is_additional) {
        this.to_additional_rate_fieldTarget.classList.add('hidden');
      } else {
        this.to_additional_rate_fieldTarget.classList.remove('hidden');
      }
    }
  }

  // Override validateExpenseAmount to also update exchange rates
  async validateExpenseAmount(event) {
    const amount = this.getAmountValue();
    const selectedCurrency = this.getSelectedCurrency();
    
    // Clear previous validation message
    this.hideValidationMessage();
    
    if (!amount || amount <= 0 || !selectedCurrency) {
      return;
    }

    // Update exchange rates with new amount (for expense forms only)
    if (this.isExpenseForm()) {
      this.loadDynamicExchangeRates(selectedCurrency, amount);
    }
    
    // Find available balance for selected currency
    if (this.availableBalances) {
      const currencyBalance = this.availableBalances.find(b => b.currency === selectedCurrency);
      if (currencyBalance) {
        const amountCents = Math.round(amount * 100);
        
        if (amountCents > currencyBalance.balance_cents) {
          this.showValidationMessage(this.validation_messageTarget.dataset.insufficientFunds,'danger');
        }
      }
    }
  }

}